module.exports = __webpack_public_path__ + "img/app-window-error-404.13149f06.svg";